(function(){
var $=function(s,r){return(r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
function money(c){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100)}catch(e){return(c/100).toFixed(2)}}
function drawer(){return $('#drawer')}
function open(){var d=drawer();if(d)d.classList.add('open')}
function render(c){
 var box=$('#items');if(!box)return;box.innerHTML='';
 if(!c.items.length){var p=document.createElement('p');p.className='empty';p.textContent='Your cart is empty. Add something from the collection.';box.appendChild(p)}
 c.items.forEach(function(it){
  var r=document.createElement('div');r.className='row';
  var a=document.createElement('span');a.textContent=it.product_title+' x '+it.quantity;
  var b=document.createElement('span');b.textContent=money(it.final_line_price);
  var x=document.createElement('button');x.textContent='\u00d7';x.setAttribute('aria-label','Remove');x.dataset.remove=it.key;
  b.appendChild(x);r.appendChild(a);r.appendChild(b);box.appendChild(r)});
 var t=$('#total');if(t)t.textContent=money(c.total_price);
 $$('[data-count]').forEach(function(e){e.textContent=c.item_count})}
function load(){return fetch('/cart.js').then(function(r){return r.json()}).then(render)}
function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})}
function add(id){return post('/cart/add.js',{id:Number(id),quantity:1}).then(load).then(open)}
document.addEventListener('click',function(e){
 var t=e.target;
 if(t.dataset.add){add(t.dataset.add)}
 if(t.dataset.remove){post('/cart/change.js',{id:t.dataset.remove,quantity:0}).then(load)}
 if(t.id==='open-cart'){open()}
 if(t.id==='close-cart'){drawer().classList.remove('open')}
 if(t.dataset.tab!==undefined){
  var sec=t.closest('section');
  $$('[data-tab]',sec).forEach(function(b){b.setAttribute('aria-selected',b===t)});
  $$('.tab-panel',sec).forEach(function(p){p.hidden=p.dataset.panel!==t.dataset.tab})}
});
document.addEventListener('submit',function(e){
 var f=e.target;if(!f.hasAttribute('data-product-form'))return;
 e.preventDefault();var id=f.elements.id.value;add(id)});
var h=$('#hero'),g=$('#glow');
if(h&&g)h.addEventListener('mousemove',function(e){g.style.transform='translate('+(e.clientX/innerWidth-.5)*60+'px,'+(e.clientY/innerHeight-.5)*60+'px)'});
var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{threshold:.15});
$$('.reveal').forEach(function(r){io.observe(r)});
load();
})();